import React, {useMemo} from 'react';

import styles from './TextArea.module.css'
import {useScreenDetector} from "../../../hooks/useScreenDetector.ts";

interface Props {
    value?: string,
    cols?: number,
    onInput: (text: string) => void
}

export const TextArea: React.FC<Props> = ({onInput, value, cols = 80}) => {
    const {isMobile} = useScreenDetector()

    const rows = useMemo(() => isMobile ? 2 : 10, [isMobile])

    return (
        <div className={styles.comment}>
            <h3>Комментарий</h3>
            <textarea
                className={styles.commentInput}
                cols={cols}
                rows={rows}
                value={value}
                onChange={(e) => {
                onInput(e.target.value)
            }}/>
        </div>
    );
};